import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * v1.29.21 — Dark solid green (green-600 = #16a34a) selected state with a
 * bold white checkmark, matching the app-wide native-checkbox style set in
 * index.css. Previously the tick used `bg-primary` which resolves to a very
 * light green on the current theme — hard to see on the Payment Slips row
 * selection. Border also flips to green-600 when checked so the whole box
 * reads as a solid dark-green pill.
 * v1.29.25 — Anchored to the user's exact spec `#16a34a` (Tailwind green-600).
 */
const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-4 w-4 shrink-0 rounded-sm border border-slate-400 shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-green-600 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-green-600 data-[state=checked]:border-green-600 data-[state=checked]:text-white",
      className
    )}
    {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-white")}>
      <Check className="h-4 w-4 stroke-[3]" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
